<template>
  <div class="row">
    <div class="col-12 active">
      <div class="card active">
        <div class="card-body mini-nav bg-primary pt-2 pb-3 active">
          <nav class="navbar navbar-expand-md navbar navbar-dark bg-primary py-2 active">
            <button
                class="navbar-toggler btn btn-sm px-3 font-size-16 header-item waves-effect h-auto text-primary"
                type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup"
                aria-controls="navbarNavAltMarkup" aria-expanded="false"
                aria-label="Toggle navigation">
              <span class="mdi mdi-menu"></span>
            </button>
            <div class="collapse navbar-collapse justify-content-between active" id="navbarNavAltMarkup">
              <div class="navbar-nav">

                <router-link v-if="getRight('LAND DASHBOARD')" :to="{name: 'clearance-dashboard'}" active-class="mm-active" class="nav-item nav-link">
                  <i class="mdi mdi-clock-outline me-1"></i>Dashboard
                </router-link>

                <router-link v-if="getRight('CLEARANCE PENDING')" :to="{name: 'clearance-pending'}" active-class="mm-active" class="nav-item nav-link">
                  <i class="mdi mdi-clock-outline me-1"></i>Pending Certificates
                </router-link>
                <router-link v-if="getRight('CLEARANCE APPROVED')" :to="{name: 'clearance-approved'}" active-class="mm-active" class="nav-item nav-link">
                  <i class="mdi mdi-check-circle me-1"></i>Approved Certificates
                </router-link>
                <router-link v-if="getRight('CLEARANCE DECLINED')" :to="{name: 'clearance-declined'}" active-class="mm-active" class="nav-item nav-link">
                  <i class="mdi mdi-close-circle me-1"></i>Declined Certificates
                </router-link>
                <router-link v-if="getRight('CLEARANCE ALL')" :to="{name: 'clearance-certificates'}" active-class="mm-active" class="nav-item nav-link">
                  <i class="mdi mdi-file-certificate me-1"></i>All Certificates
                </router-link>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getRight } from "@/api";

export default {
  name: "ToolBarClearance",
  methods: {
    getRight(type) {
      return getRight(type);
    }
  }
}
</script>

<style scoped>
.nav-item.nav-link {
  display: flex;
  align-items: center;
}

.nav-item.nav-link i {
  font-size: 1.1rem;
}

.mm-active {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}
</style>